import moment from 'moment'

export default [
  {
    text: '今天',
    onClick(picker) {
      const start = new Date()
      const end = new Date()
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '昨天',
    onClick(picker) {
      const start = moment().subtract(1, 'days').toDate()
      picker.$emit('pick', [start, start])
    }
  },
  {
    text: '本周',
    onClick(picker) {
      const start = moment().weekday(0).toDate()
      const end = moment().toDate()
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '近7天',
    onClick(picker) {
      const start = moment().subtract(6, 'days').toDate()
      const end = moment().toDate()
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '上周',
    onClick(picker) {
      const start = moment().weekday(-7).toDate()
      const end = moment().weekday(-1).toDate()
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '本月',
    onClick(picker) {
      const start = moment().date(1).toDate()
      const end = moment().toDate()
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '上个月',
    onClick(picker) {
      const start = moment().date(1).subtract(1, 'months').toDate()
      const end = moment().date(1).subtract(1, 'days').toDate()
      picker.$emit('pick', [start, end])
    }
  }
]
